module.exports = __webpack_public_path__ + "static/media/shanghai.e20355d6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shanghai.jpeg
// module id = 1547
// module chunks = 0